import { defaultPathParams, URL, urlTemplates } from 'api/urls';
import { api } from '..';
import { isUserLoggedIn, replacePlaceholder } from 'utils/commonFunctions';
import { PLATFORM_ID } from 'utils/constants';

const defaultParams = {
  Lang: 'en',
  PlatformId: PLATFORM_ID
  // isGuestUser: false
};

export const feedsApi = api.injectEndpoints({
  endpoints: (builder) => {
    return {
      login: builder.mutation({
        query: ({ payload /*, token*/ }) => {
          return {
            url: replacePlaceholder(urlTemplates.login, { ...defaultPathParams, version: 'v3' }),
            method: 'POST',
            data: {
              ...payload
            }
            // headers: {
            //   Authorization: `Bearer ${token}` // Pass the token in the headers
            // }
          };
        }
      }),
      getUserDetails: builder.query({
        query: (quizId) => {
          return {
            url: replacePlaceholder(urlTemplates.getUserDetails, {
              ...defaultPathParams,
              quizId
            }),
            params: { ...defaultParams },
            method: 'POST',
            data: {
              isGuestUser: isUserLoggedIn() ? false : true
            }
          };
        }
      }),
      userAttempt: builder.query({
        query: ({ QuizId, ...rest }) => {
          return {
            url: replacePlaceholder(urlTemplates.userAttempt, {
              ...defaultPathParams,
              quizId: QuizId
            }),
            params: {
              ...defaultParams,
              ...rest
            },
            method: 'POST',
            data: {
              isGuestUser: isUserLoggedIn() ? false : true
            }
          };
        }
      }),
      settelment: builder.query({
        query: ({ quizId, ...rest }) => {
          return {
            url: replacePlaceholder(urlTemplates.settelment, {
              ...defaultPathParams,
              quizId
            }),
            params: {
              ...defaultParams,
              ...rest
            },
            method: 'POST',
            data: {
              isGuestUser: isUserLoggedIn() ? false : true
            }
          };
        }
      }),

      registerQuestion: builder.mutation({
        query: ({ QuizId, ...rest }) => {
          return {
            url: replacePlaceholder(urlTemplates.registerQuestion, {
              ...defaultPathParams,
              version: 'v3',
              quizId: QuizId
            }),
            params: {
              ...defaultParams,
              ...rest
            },
            method: 'POST',
            data: {
              isGuestUser: isUserLoggedIn() ? false : true
            }
          };
        }
      }),
      fiftyFiftyBooster: builder.mutation({
        query: ({ quizId, ...rest }) => {
          return {
            url: replacePlaceholder(urlTemplates.fiftyFiftyBooster, {
              ...defaultPathParams,
              quizId
            }),
            params: {
              ...defaultParams,
              ...rest
            },
            method: 'POST',
            data: {
              isGuestUser: isUserLoggedIn() ? false : true
            }
          };
        }
      }),

      thirdUmpireBooster: builder.mutation({
        query: ({ quizId, ...rest }) => {
          return {
            url: replacePlaceholder(urlTemplates.thirdUmpireBooster, {
              ...defaultPathParams,
              quizId
            }),
            params: {
              ...defaultParams,
              ...rest
            },
            method: 'POST',
            data: {
              isGuestUser: isUserLoggedIn() ? false : true
            }
          };
        }
      }),
      scoreCard: builder.mutation({
        query: ({ quizId, ...rest }) => {
          return {
            url: replacePlaceholder(urlTemplates.scoreCard, {
              ...defaultPathParams,
              quizId,
              version: 'v3'
            }),
            params: {
              ...defaultParams,
              ...rest
            },
            data: {
              isGuestUser: isUserLoggedIn() ? false : true
            },
            method: 'POST'
          };
        }
      })
    };
  }
});

export const {
  useLoginMutation,
  useGetUserDetailsQuery,
  useUserAttemptQuery,
  useLazySettelmentQuery,
  useRegisterQuestionMutation,
  useFiftyFiftyBoosterMutation,
  useThirdUmpireBoosterMutation,
  useScoreCardMutation
} = feedsApi;
